(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mounted = new WeakMap();
  function mount(scope = document) {
    const videos = scope.matches?.('[data-kinora-video]') ? [scope] : scope.querySelectorAll('[data-kinora-video]');
    videos.forEach(video => {
      if (mounted.has(video)) return;
      const controller = new AbortController();
      const signal = controller.signal;
      const connection = navigator.connection;
      let inView = false;
      let warmed = false;
      let disposed = false;
      video.controls = false;
      video.autoplay = false;
      video.defaultMuted = true;
      video.muted = true;
      video.loop = true;
      const constrained = () => Boolean(connection?.saveData) || reduced.matches;
      const warm = () => {
        if (disposed) return;
        if (!video.poster && video.dataset.poster) video.poster = video.dataset.poster;
        if (warmed || constrained()) return;
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        warmed = true;
        video.preload = 'auto';
        video.load();
      };
      const pause = () => {
        video.autoplay = false;
        if (!video.paused) video.pause();
      };
      const resume = () => {
        if (disposed || !inView || document.hidden || constrained()) return;
        warm();
        video.autoplay = true;
        video.play().catch(() => {});
      };
      const refresh = () => { if (document.hidden || constrained()) pause(); else resume(); };
      video.addEventListener('loadeddata', resume, { signal });
      video.addEventListener('contextmenu', event => event.preventDefault(), { signal });
      document.addEventListener('visibilitychange', refresh, { signal });
      reduced.addEventListener('change', refresh, { signal });
      connection?.addEventListener('change', refresh, { signal });
      let nearObserver;
      let visibleObserver;
      if ('IntersectionObserver' in window) {
        nearObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { warm(); nearObserver.disconnect(); }
        }, { rootMargin: '400px 0px' });
        visibleObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          inView = entry.isIntersecting && entry.intersectionRatio >= .15;
          video.dataset.inView = String(inView);
          if (inView) resume(); else pause();
        }, { threshold: [0, .15, .6] });
        nearObserver.observe(video);
        visibleObserver.observe(video);
      } else {
        inView = true;
        warm();
        resume();
      }
      mounted.set(video, () => {
        disposed = true;
        pause();
        controller.abort();
        nearObserver?.disconnect();
        visibleObserver?.disconnect();
        mounted.delete(video);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-kinora-video]').forEach(video => mounted.get(video)?.()));
})();
